import { toast } from "react-toastify";

import { msalInstance } from "../../index";
import { acquireAccessToken } from "../../scripts/helperScripts";

const apiUrl = "https://safyzetoapi.azurewebsites.net";

async function zetoGet(uri, signal) {
  try {
    if (msalInstance.getActiveAccount() !== null) {
      var accessToken = await acquireAccessToken(msalInstance);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${accessToken.accessToken}`);

      var requestOptions = {
        method: "GET",
        headers: myHeaders,
        signal: signal,
      };

      return fetch(uri, requestOptions)
        .then(function (response) {
          return response.json();
        })
        .then(function (result) {
          if (result.code === "fail") {
            console.log("FAIL", result);
          }
          return result;
        });
    }
    return null;
  } catch (err) {
    return "error:" + err;
  }
}

export async function zetoPost(uri, body, signal) {
  var accessToken = await acquireAccessToken(msalInstance);
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${accessToken.accessToken}`);

  var requestOptions = {
    method: "POST",
    body: JSON.stringify(body),
    headers: myHeaders,
    signal: signal,
  };

  return fetch(uri, requestOptions)
    .then(function (response) {
      return response.json();
    })
    .then(function (result) {
      return result;
    });
}

export async function getMessagesForUser(soarUserId, signal) {
  const response = await zetoGet(
    `${apiUrl}/FPReact/Discussion/Outstanding/${soarUserId}`,
    signal
  );
  return response.data;
}

export function saveMessage(message, trigger) {
  return zetoPost(`${apiUrl}/FPReact/Discussion/Upsert/${trigger}`, message);
}

export async function getWeeklyReport(clientId, beginDate, endDate, signal) {
  const response = await zetoGet(
    `${apiUrl}/FPReact/Reports/GridWeek/${clientId}/${beginDate}/${endDate}`,
    signal
  );
  return response.data;
}

export async function getClientsByDivisionForApproval(division, signal) {
  const response = await zetoGet(
    `${apiUrl}/FPApproval/Clients/${division}`,
    signal
  );
  return response.data;
}

export async function getServicesForApprovalByClient(clientId, signal) {
  const response = await zetoGet(
    `${apiUrl}/FPApproval/Client/Services/${clientId}`,
    signal
  );
  return response.data;
}

export function revertDraft(recordedServiceId, signal) {
  return zetoGet(
    `${apiUrl}/FPApproval/Service/Revert/${recordedServiceId}`,
    signal
  );
}

export async function confirmService(service) {
  const response = await zetoPost(
    `${apiUrl}/FPApproval/Service/Confirm`,
    service
  );
  return response.data[0];
}

export async function confirmServices(services) {
  const response = await zetoPost(
    `${apiUrl}/FPApproval/Services/Confirm`,
    services
  );
  return response.data[0];
}

export function deactivateService(recordedServiceId, signal) {
  return zetoGet(
    `${apiUrl}/FPApproval/Service/Deactivate/${recordedServiceId}`,
    signal
  );
}

export async function getServicesForClientsByDates(
  clientId,
  startDate,
  endDate
) {
  const body = {
    ClientIds: [clientId],
    StartDate: startDate,
    EndDate: endDate,
  };
  const response = await zetoPost(
    `${apiUrl}/FPApproval/Clients/Services/DuplicateCheck`,
    body
  );

  return response.data[0];
}

export async function getCensusPayors() {
  const response = await zetoGet(`${apiUrl}/Census/Payors`);

  return response.data;
}

export async function getCensusPayor(id) {
  const response = await zetoGet(`${apiUrl}/Census/Payor/${id}`);

  return response.data;
}

export async function getCensusGroupPlans() {
  const response = await zetoGet(`${apiUrl}/Census/GroupPlans`);

  return response.data;
}

export async function censusPayorAction(action, body) {
  const response = await zetoPost(`${apiUrl}/Census/${action}/Payor/`, body);

  return response.data;
}

export async function censusGroupPlanAction(action, body) {
  const response = await zetoPost(
    `${apiUrl}/Census/${action}/GroupPlan/`,
    body
  );

  return response.data;
}

export async function getSPDocumentsForId(id, type, state) {
  const body = {
    field: type,
    value: id,
  };
  const resp = await zetoPost(
    `${apiUrl}/System/Document/Libraries/${state}/Filtered`,
    body
  );

  if (resp?.data?.value) return resp.data.value;
  else {
    toast.error(`Error fetching documents: ${resp.message}`);
    return null;
  }
}

export async function getSPDocumentLibraries() {
  const resp = await zetoGet(`${apiUrl}/System/Document/Libraries/List`);

  return resp;
}

export async function sharePoint(body) {
  const resp = await zetoPost(`${apiUrl}/Graph/Request`, body);

  return resp;
}

export async function perDiem(path, body, signal) {
  try {
    return zetoPost(`${apiUrl}/PerDiem/${path}`, body, signal);
  } catch (err) {
    return "error:" + err;
  }
}

export async function perDiemContact(body, signal) {
  try {
    return zetoPost(`${apiUrl}/PerDiem/Residences/Contacts`, body, signal);
  } catch (err) {
    return "error:" + err;
  }
}

export async function perDiemContactAssignment(body, signal) {
  try {
    return zetoPost(
      `${apiUrl}/PerDiem/Residences/Assignments/Contacts`,
      body,
      signal
    );
  } catch (err) {
    return "error:" + err;
  }
}

export async function perDiemClientAssignment(body, signal) {
  try {
    return zetoPost(
      `${apiUrl}/PerDiem/Residences/Assignments/Clients`,
      body,
      signal
    );
  } catch (err) {
    return "error:" + err;
  }
}

export async function perDiemResidences(body, signal) {
  try {
    return zetoPost(`${apiUrl}/PerDiem/Residences`, body, signal);
  } catch (err) {
    return "error:" + err;
  }
}

export async function perDiemLease(body, signal) {
  try {
    return zetoPost(`${apiUrl}/PerDiem/Residences/Leases`, body, signal);
  } catch (err) {
    return "error:" + err;
  }
}

export async function perDiemUtility(body, signal) {
  try {
    return zetoPost(`${apiUrl}/PerDiem/Residences/Utilities`, body, signal);
  } catch (err) {
    return "error:" + err;
  }
}

export async function perDiemRelated(body, signal) {
  try {
    return zetoPost(`${apiUrl}/PerDiem/Residences/Related`, body, signal);
  } catch (err) {
    return "error:" + err;
  }
}

export async function perDiemNotes(body, signal) {
  try {
    return zetoPost(`${apiUrl}/PerDiem/Residences/Notes`, body, signal);
  } catch (err) {
    return "error:" + err;
  }
}

export async function clientList(body, signal) {
  try {
    return zetoPost(`${apiUrl}/SOAR/Clients`, body, signal);
  } catch (err) {
    return "error:" + err;
  }
}

export async function crisisReferrals(body, signal) {
  try {
    return zetoPost(`${apiUrl}/crisis/referrals`, body, signal);
  } catch (err) {
    return "error:" + err;
  }
}

export async function crisisResponder(body, signal) {
  try {
    return zetoPost(`${apiUrl}/crisis/referrals/responders`, body, signal);
  } catch (err) {
    return "error" + err;
  }
}

export async function reactManagementUsers(body, signal) {
  try {
    return await zetoPost(`${apiUrl}/react/assignments/modules`, body, signal);
  } catch (err) {
    return "error" + err;
  }
}
